// extracted by mini-css-extract-plugin
module.exports = {"main":"Image_main__gT4aM","search-fade-in":"Image_search-fade-in__aCAqs"};